import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Menu.css';
import LoginAlert from '../LoginAlert/LoginAlert';
import { useMenuStore } from './useMenuStore'; // Import Zustand store

function Menu() {
    const [showLoginAlert, setShowLoginAlert] = React.useState(false);
    const { activeMenuId, setActiveMenuId } = useMenuStore(); // Use Zustand for activeMenuId
    const navigate = useNavigate();
    const location = useLocation(); // Get the current route
    const notDark = localStorage.getItem("veeu-dark-mode") === "false"

    const menuItems = [
        { id: 5, src: notDark ? "/icons/pelake-man-home-menu.svg" : "/icons/dark-home.svg", alt: 'خانه', link: '/', active: '/icons/active-home-nav.svg' },
        { id: 3, src: "/icons/pelake-man-add-circle-menu.svg", alt: 'ثبت آگهی', link: '/CreateFile', active: '/icons/active-register-nav.svg' },
        { id: 1, src: notDark ? "/icons/pelake-man-user-menu.svg" : "/icons/dark-user-icon.svg", alt: 'پروفایل', link: '/Profile', active: '/icons/active-profile-nav.svg' },
    ];

    // Effect to update the active menu based on current route
    useEffect(() => {
        if (location.pathname === '/') {
            setActiveMenuId(5);
        } else if (location.pathname === '/CreateFile') {
            setActiveMenuId(3);
        } else if (location.pathname === '/Profile') {
            setActiveMenuId(1);
        }
    }, [location, setActiveMenuId]);

    const checkAuthForAddOrder = (id) => {
        if (localStorage.getItem('pelakAuthData')) {
            setActiveMenuId(id); // Set the active icon first
            if (id === 3) {
                navigate('/CreateFile');
            } else if (id === 1) {
                navigate('/Profile');
            }
        } else {
            setShowLoginAlert(true);
        }
    };

    return (
        <>
            <div className='h-16 min-h-16 max-h-16 w-full hidden sm:block md:block lg:block mobile-menu' id='bottom-menu'>
                <div className=' w-full h-14 min-h-16 max-h-16 z-30 py-2 fixed bottom-0 flex items-center justify-around border-t shadow-sm rounded-t-3xl bg-[#f0f8ffa1] backdrop-blur-sm dark:bg-[#414141]'>
                    {menuItems.map((item) =>
                        item.id === 3 || item.id === 1 ? (
                            <div onClick={() => checkAuthForAddOrder(item.id)} key={item.id} className='flex flex-col items-center justify-center gap-2 w-1/3'>
                                <img src={activeMenuId === item.id ? item.active : item.src} alt={item.alt} />
                            </div>
                        ) : (
                            <Link
                                onClick={() => setActiveMenuId(item.id)} // Set active icon when navigating through Link
                                key={item.id}
                                to={item.link}
                                className='flex flex-col items-center justify-center gap-2 w-1/3'
                            >
                                <img src={activeMenuId === item.id ? item.active : item.src} alt={item.alt} />
                            </Link>
                        )
                    )}
                </div>
            </div>
            {showLoginAlert ? <LoginAlert showLoginAlert={showLoginAlert} setShowLoginAlert={setShowLoginAlert} /> : ''}
        </>
    );
}

export default Menu;